import { PRESENCE_NAMESPACE } from "@livcg/schema";

export type PresenceClient = {
  id?: string;
  connected: boolean;
  connect(): void;
  emit(event: string, data?: unknown): void;
  on(event: string, cb: (data: never) => void): void;
  off(event: string, cb: (data: never) => void): void;
};

/** A namespace socket on the Manager NodeCG already opened (same cookie, no new dependency). */
export function presenceSocket(): PresenceClient | null {
  const main = (window as unknown as { socket?: { io?: { socket(nsp: string): PresenceClient } } })
    .socket;
  return main?.io?.socket(PRESENCE_NAMESPACE) ?? null;
}
